import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class LoginPromptService {
	private readonly loginRequiredSubject = new Subject<void>()

	readonly loginRequired$ = this.loginRequiredSubject.asObservable()

	showLoginRequired() {
		this.loginRequiredSubject.next()
	}
}
